<template>
    <section class="splash">
        <div class="parent-wrapper">
            <div class="splash__header-image">
                <div class="splash__header-bar"></div>
            </div>
            <div class="heading-container">
                <h1>
                    <span>
                        <span class="padding-helper">Sammeln Sie</span><br />
                        <span class="padding-helper">Bausteine für Ihren</span><br />
                        <span class="padding-helper">HausbankBonus</span>
                    </span>
                </h1>
                <h2>
                    <span>Morgen kann kommen.</span>
                </h2>
                <h3>
                    <span>Wir machen den Weg frei.</span>
                </h3>
            </div>
        </div>
        <div class="splash-content">
            <div class="splash__inner">
                <div class="splash__content">
                    <div class="video">
                        <video
                            src="../../public/assets/videos/introvideo.mp4"
                            width="640"
                            height="360"
                            controls=""
                            poster="../../public/assets/videos/introvideo-poster.jpg"
                        ></video>
                    </div>
                </div>
                <footer class="splash__footer">
                    <checkbox v-model="isChecked" @click="isChecked = !isChecked">
                        <span
                            class="small-text color-gray align-left"
                            v-html="
                                $t('splashscreen.terms', {
                                    privacy: $t('splashscreen.privacy-policy'),
                                    privacy2: $t('splashscreen.privacy-policy-2'),
                                    termsofuse: $t('splashscreen.terms-of-use'),
                                })
                            "
                        />
                    </checkbox>

                    <div class="input-block">
                        <label class="label" for="input-code">
                            {{ $t('splashscreen.enter-code') }}
                        </label>
                        <input
                            class="code-input"
                            maxlength="8"
                            type="text"
                            id="input-code"
                            name="Code"
                            v-model="code"
                        />
                    </div>

                    <div v-if="getPersonalData.sharedClient" class="splash__shared-client">
                        <div class="columns is-mobile">
                            <div class="column is-narrow">
                                <app-icon icon="shared-client" size-px="24px" />
                            </div>
                            <div class="column">
                                <p>
                                    <strong>Hinweis Gemeinschaftskunden:</strong> Sie sind mit dem Hausbankcode Ihres
                                    Gemeinschaftskundenstamms eingeloggt, daher kann der Ihnen im HausbankBonus-Finder
                                    angezeigte Status von Ihrem Status, der den Kontovorteil bestimmt, abweichen.
                                </p>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn--cta btn--rounded btn--icon" :disabled="isDisabled" @click="submit">
                        {{ isLoading ? $t('splashscreen.is-loading') : $t('splashscreen.submit-btn') }}
                        <svg v-if="!isLoading" class="icon" width="16px" height="16px">
                            <use xlink:href="#icon-arrow-right" />
                        </svg>
                    </button>
                </footer>
            </div>
        </div>
        <div class="copyright">
            Bildnachweis: fizkes
        </div>
    </section>
</template>

<script>
import Checkbox from '@/components/Checkbox';
import AppIcon from '@/components/AppIcon';

export default {
    components: { AppIcon, Checkbox },
    data() {
        return {
            cookieConsent: false,
            isChecked: false,
            code: '',
        };
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('code') && urlParams.get('code').length > 0) {
            this.code = urlParams.get('code');
        }
    },
    computed: {
        getPersonalData() {
            return this.$store.getters['getPersonalData'];
        },
        isLoading() {
            return this.$store.getters['getApiIsLoading'];
        },
        isDisabled() {
            return !(this.isChecked && !this.isLoading);
        },
    },
    methods: {
        /*
        Update: 2020-12-21 App can just start with tracking enabled!
        submitNoTracking() {
            this.$matomo && this.$matomo.forgetConsentGiven();
            this.$store.commit('UPDATE_SPLASHSCREEN', false);
        },
        */
        submit() {
            if (this.isLoading) {
                // do not call action if loading
                return;
            }

            this.$matomo && this.$matomo.setConsentGiven();
            this.$matomo && this.$matomo.rememberConsentGiven(24 * 90); // 24h * 90d

            if (this.code && this.code.length > 0) {
                this.$store
                    .dispatch('activatePrefilledMode', this.code)
                    .then(() => {
                        this.$matomo && this.$matomo.trackEvent('Sitzung', 'start', 'mit Code');
                        this.$store.commit('UPDATE_SPLASHSCREEN', false);
                    })
                    .catch(() => {
                        this.$matomo && this.$matomo.trackEvent('Sitzung', 'start', 'ohne Code');
                        this.$store.commit('UPDATE_SPLASHSCREEN', false);
                    });
            } else {
                this.$matomo && this.$matomo.trackEvent('Sitzung', 'start', 'ohne Code');
                this.$store.commit('UPDATE_SPLASHSCREEN', false);
            }
        },
    },
};
</script>
